import axios from 'axios'

const START_URL = '/api/v1/insure/insurance/application/start/'

/** Builds a stub account for a signed-out visitor and returns the one-use ticket that signs into it.
 *  A trade (from a trade page's link) starts a contractor application when the backend offers one; the
 *  page's query string goes along so a flag's testing parameter (dwft_<flag>) reaches the backend. */
export async function startAnonymousApplication(
  trade?: string | null,
  query = '',
  contractor = false
): Promise<string> {
  const body = { ...(trade ? { trade } : {}), ...(contractor ? { line_of_business: 'CONTRACTOR' } : {}) }
  const response = await axios.post<{ ticket: string }>(`${START_URL}${query}`, body)
  return response.data.ticket
}
